module.exports = __webpack_public_path__ + "static/img/zqlhzq7977817.png";